<template>
  <ul class="sub-menu sub-menu-page navbar-nav pl-0">
    <li v-for="(menu,index) in menuJson[subMenuName]"
        v-if="checkPermission(menu)"
        :key="index"
        class=" menuMobileT">
      <menu-item :name="$t(menu.text)"
                 :icon="menu.icon"
                 :link="menu.link" />
      <div v-if="menu.sub.length > 0"
           class="sub-menu-w">
        <div class="sub-menu-i " >
          <ul class="sub-menu sub-menu-page navbar-nav pl-0">
            <router-link
              v-for="(menuSub,index) in menu.sub"
              v-if="checkPermission(menuSub)"
              :key="index"
              :to="{ path: menuSub.link }"
              :class="[{ active: $route.path.includes(menuSub.routeGlobal)}]"
              tag="li"
            >
              <menu-item :name="$t(menuSub.text)"
                         :link="menuSub.link" />
            </router-link>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</template>
<script>
import menuJson from '@/components/app/user/partials/navbar/menu.json'
import MenuItem from './MenuItem.vue'
import { mapState } from 'vuex'
import MenuHeader from '@/components/app/user/partials/navbar/web/mainMenu/MenuHeader'
export default {
	name: 'sub-menu',
	components: { MenuItem, MenuHeader },
	data () {
		return {
			menuJson: menuJson,
			activeshow: false
		}
	},
	computed: {
		...mapState('User', ['permissions'])
	},
	methods: {
		checkPermission (menu) {
			if (menu.permissionName) {
				let find1 = this.permissions.find(
					a => a.permissionName === menu.permissionName
				)
				if (find1) return true
			}

			let sub = menu.sub
			let exist = false
			if (!sub || sub.length < 1) return true

			if (sub.length > 0) {
				sub.map(s => {
					if (!s.permissionName) {
						exist = true
						return true
					}
					let find = this.permissions.find(
						a => a.permissionName === s.permissionName
					)
					if (find) {
						exist = true
						return true
					}
				})
				return exist
			}

			return false
		}
	},
	props: {
		subMenuName: {
			type: String,
			default: null
		}
	}

}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/mobile/subMenu/index.vue